// eslint-disable-next-line import/prefer-default-export
export { default as iconNames } from './iconNames';




// WEBPACK FOOTER //
// ./src/public/constants/index.js